<template>
  <div class="flex flex-wrap pt-10 px-10 w-full">
    <div class="flex w-full justify-start ">
      <NavigationFilterComponent class="transform origin-left scale-150" />
    </div>

    <div class="w-10/12 flex items-center">
      <div class="relative w-48 z-50 cursor-pointer" @click="goToHome()">
        <img :src="logo" alt="educational logo" />
      </div>
      <FiltersComponent v-if="!isVideoView" class="" :isMobile="false" />
    </div>
  </div>
</template>

<style scoped>
.utility-fixed {
  position: fixed;
  right: 9vw;
  top: 32vh;
}

.transform {
  -ms-transform-origin: 0 50%;
  -webkit-transform-origin: 0 50%;
  transform-origin: 0 50%;
  /* transform: scale(1.5); */
}
</style>

<script>
// Components
import UtilityComponent from "../components/base/UtilityComponent";
import NavigationFilterComponent from "../components/NavigationFilterComponent";
import FiltersComponent from "../components/FiltersComponent";

// Assets
import logo from "../assets/logo-small.png";

export default {
  components: {
    UtilityComponent,
    NavigationFilterComponent,
    FiltersComponent,
  },
  data() {
    return {
      logo,
      isVideoView: false,
    };
  },
  watch: {
    $route(to) {
      this.isVideoView = to.path === "/video";
    },
  },
  methods: {
    goToHome() {
      const home = document.getElementById("nav-button-0");
      if (home) home.click();
      const currentRoute = this.$router.currentRoute.path;
      if (currentRoute !== "/") this.$router.push("/");
    },
  },
};
</script>
